import React from "react"
import { firestore } from "../../core"
import { useFollowingUsers } from "popopo-lib-front/firestore-access"
import { NavLink } from "react-router-dom"
import * as FirebaseAuth from "firebase/auth"
import { UserDocument } from "popopo-msg"
import { Paths } from "../../paths"


export const FollowingUserList = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const users = useFollowingUsers(firestore, props.user.id, 100)

  return (
    <>
      <ul className="list-group w-100">
        {users === "loading" ? (
          <li>
            <i className="fas fa-spin fa-spinner" />
          </li>
        ) : users.length === 0 ? (
          <li>ユーザーは1人も存在しません。</li>
        ) : (
          users.map((user) => (
            <li key={user.followee?.id} className="list-group-item">
              <NavLink to={Paths.users.user.getPath(user.followee.id)}>
                <img src={user.followee.icon} width={48} height={48} />
                 ID: {user.followee?.id} (Name: {user.followee.name})
              </NavLink>
            </li>
          ))
        )}
      </ul>
    </>
  )
}
